var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPaymentFailed = function SvgPaymentFailed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "payment failed_icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-failed_icon",
    transform: "translate(-3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "current",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/send_money",
    transform: "translate(7.875000, 22.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3215159,3.82745775 L11.3215159,2.19017421 C11.3215159,0.980574392 12.3020903,0 13.5116901,0 L52.9348258,0 C54.1444256,0 55.125,0.980574392 55.125,2.19017421 L55.125,21.9017421 C55.125,23.1113419 54.1444256,24.0919163 52.9348258,24.0919163 L13.5116901,24.0919163 C12.3020903,24.0919163 11.3215159,23.1113419 11.3215159,21.9017421 L11.3215159,19.7201232",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.7286828,
    cy: 12.9725703,
    r: 5.89662286
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.36949878,
    y1: 7.21915113,
    x2: 15.213287,
    y2: 7.21915113,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.5994995 C0,11.5994995 6.23357274,11.5994995 18.7007182,11.5994995",
    id: "Line-3-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.00613157,
    y1: 15.979848,
    x2: 15.8619155,
    y2: 15.979848,
    id: "Line-3-Copy-2",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(46.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7978958,4.54100975 L31.8156562,25.5081662 C32.6395733,26.9456385 32.1421885,28.7788568 30.7047162,29.6027739 C30.2506054,29.8630569 29.7362979,30 29.2128823,30 L5.17736155,30 C3.5205073,30 2.17736155,28.6568542 2.17736155,27 C2.17736155,26.4765844 2.31430466,25.962277 2.57458767,25.5081662 L14.5923481,4.54100975 C15.4162651,3.10353743 17.2494834,2.60615262 18.6869558,3.43006968 C19.1493826,3.69511923 19.5328463,4.07858287 19.7978958,4.54100975 Z",
    id: "Triangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    fill: "#B50073"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.365854, 10.243902)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94038659,-2.05526653e-15 C0.87377561,-2.05526653e-15 4.79562189e-15,0.860238567 4.79562189e-15,1.92684954 L0.396199543,8.86892271 C0.396199543,9.71558567 1.08014802,10.4131098 1.94038659,10.4131098 C2.78704954,10.4131098 3.47103659,9.71558567 3.47103659,8.86892271 L3.86723613,1.92684954 C3.86723613,0.860238567 2.9919564,-2.05526653e-15 1.94038659,-2.05526653e-15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94038659,11.5612515 C0.87377561,11.5612515 4.79562189e-15,12.4214901 4.79562189e-15,13.4881011 C4.79562189e-15,14.554712 0.875279726,15.4149506 1.94038659,15.4149506 C2.9919564,15.4149506 3.86723613,14.554712 3.86723613,13.4881011 C3.86723613,12.4214901 2.9919564,11.5612515 1.94038659,11.5612515 Z",
    id: "Path"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentFailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment_failed.0fee896e.svg";
export { ForwardRef as ReactComponent };